import DeliveryPeriodsStore from '../store/DeliveryPeriodsStore';
import { fetchFromJson } from './fetchFromJson';

const db = new DeliveryPeriodsStore('deliveryPeriodsStore');

const updateCache = 'deliveryPeriods_updateCache';
const getUpdateCache = (data) => data.delivery_periods;
const toast = 'Delivery Periods Updated';
const entityName = 'deliveryPeriods';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});
